export const formatToRoundoff = (value) => {
    if(value === null) return 0;
    return parseFloat(value).toFixed(4);
}
